/* DXN sponsor number → extra 5% (20% total). Custom element for snippets/cart-sponsor-code.liquid.
   Loaded from sections/cart-drawer.liquid on EVERY page (also with an empty cart) so the element is defined before the drawer
   is re-rendered via innerHTML after add-to-cart (scripts inside re-rendered HTML never run → that caused the "bounce" bug 16.09).
   Morfis, 09/2026 — automations/member-verification-integration/theme/ */
(function () {
  if (!window.customElements || customElements.get('cart-sponsor-code')) return;

  class CartSponsorCode extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('.cart-sponsor__form');
      this.input = this.querySelector('input[name="dxn-sponsor-number"]');
      this.btn = this.querySelector('.cart-sponsor__submit');
      this.spinner = this.querySelector('.loading-overlay__spinner');
      this.label = this.querySelector('.cart-sponsor__submit-label');
      this.msg = this.querySelector('.cart-sponsor__msg');
      this.removeBtn = this.querySelector('.cart-sponsor__remove');
      this.busy = false;
      if (this.form) this.form.addEventListener('submit', (e) => this.onSubmit(e));
      if (this.removeBtn) this.removeBtn.addEventListener('click', (e) => this.onRemove(e));
      if (this.input) this.input.addEventListener('input', () => this.showMsg(null));
      var p = CartSponsorCode.pendingMsg;
      if (p) { CartSponsorCode.pendingMsg = null; this.showMsg(p.type, p.text, 7000); }
    }

    text(key) { return this.dataset['msg' + key] || ''; }

    showMsg(type, text, autoHideMs) {
      if (!this.msg) return;
      clearTimeout(this._hideTimer);
      this.msg.classList.remove('cart-sponsor__msg--success', 'cart-sponsor__msg--error', 'cart-sponsor__msg--warn');
      if (!type || !text) { this.msg.textContent = ''; this.msg.classList.add('hidden'); return; }
      this.msg.textContent = text;
      this.msg.classList.add('cart-sponsor__msg--' + type);
      this.msg.classList.remove('hidden');
      if (autoHideMs) this._hideTimer = setTimeout(() => { if (this.msg) this.msg.classList.add('hidden'); }, autoHideMs);
    }

    setLoading(on) {
      this.busy = on;
      if (this.btn) { this.btn.disabled = on; this.btn.classList.toggle('loading', on); }
      if (this.spinner) this.spinner.classList.toggle('hidden', !on);
      if (this.label) this.label.style.visibility = on ? 'hidden' : '';
      if (this.input) this.input.disabled = on;
    }

    existingCodes() {
      return (this.dataset.appliedCodes || '').split(',').map((c) => c.trim()).filter(Boolean);
    }

    async cartUpdate(payload) {
      const res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(Object.assign({}, payload, { sections: ['cart-drawer', 'cart-icon-bubble'] })),
      });
      if (!res.ok) throw new Error('cart update ' + res.status);
      return res.json();
    }

    refresh(data) {
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function') {
        drawer.renderContents(data);
        const el = document.querySelector('cart-drawer.drawer');
        if (el) el.classList.remove('is-empty');
      } else {
        window.location.reload();
      }
    }

    async verify(number) {
      const ctrl = new AbortController();
      const timer = setTimeout(() => ctrl.abort(), 10000);
      let cartToken = '';
      try { cartToken = decodeURIComponent((document.cookie.match(/(?:^|;\s*)cart=([^;]+)/) || [])[1] || ''); } catch (e) {}
      try {
        const res = await fetch(this.dataset.endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ member_code: number, cart_token: cartToken }),
          signal: ctrl.signal,
        });
        const json = await res.json();
        return json && typeof json === 'object' ? json : { ok: false, reason: 'unavailable' };
      } catch (e) {
        return { ok: false, reason: 'unavailable' };
      } finally {
        clearTimeout(timer);
      }
    }

    async onSubmit(event) {
      event.preventDefault();
      if (this.busy) return;
      const number = ((this.input && this.input.value) || '').replace(/[\s-]+/g, '');
      if (!/^(\d{9}|\d{12})$/.test(number)) { this.showMsg('error', this.text('Invalid')); return; }
      this.showMsg(null);
      this.setLoading(true);
      const result = await this.verify(number);
      if (!result.ok || !Array.isArray(result.codes) || !result.codes.length) {
        const reason = result.reason || 'unavailable';
        if (reason === 'invalid') this.showMsg('error', this.text('Invalid'));
        else if (reason === 'rate_limited') this.showMsg('warn', this.text('Limited'));
        else this.showMsg('warn', this.text('Unavailable'));
        this.setLoading(false);
        return;
      }
      const key = this.dataset.attributeKey || 'Numer sponsora DXN';
      const keep = this.existingCodes().filter((c) => !/^DXN-/i.test(c));
      try {
        const attrs = {}; attrs[key] = String(result.attribute || number);
        const data = await this.cartUpdate({ discount: keep.concat(result.codes).join(','), attributes: attrs });
        const applied = (data.discount_codes || []).some((d) => /^DXN-/i.test(d.code || '') && d.applicable !== false);
        if (!applied) {
          const reset = {}; reset[key] = '';
          try { await this.cartUpdate({ discount: keep.join(','), attributes: reset }); } catch (e) {}
          this.showMsg('warn', this.text('Unavailable'));
          this.setLoading(false);
          return;
        }
        CartSponsorCode.pendingMsg = { type: 'success', text: this.text('Success') };
        this.refresh(data);
      } catch (e) {
        this.showMsg('warn', this.text('Unavailable'));
        this.setLoading(false);
      }
    }

    async onRemove(event) {
      event.preventDefault();
      if (this.busy) return;
      this.busy = true;
      if (this.removeBtn) this.removeBtn.disabled = true;
      const key = this.dataset.attributeKey || 'Numer sponsora DXN';
      const keep = this.existingCodes().filter((c) => !/^DXN-/i.test(c));
      try {
        const reset = {}; reset[key] = '';
        const data = await this.cartUpdate({ discount: keep.join(','), attributes: reset });
        this.refresh(data);
      } catch (e) {
        this.busy = false;
        if (this.removeBtn) this.removeBtn.disabled = false;
      }
    }
  }
  CartSponsorCode.pendingMsg = null; /* message shown after the drawer re-renders (same trick as the theme's discount field) */

  customElements.define('cart-sponsor-code', CartSponsorCode);
})();
